<template>
  <div class="rb-input-text">
    <div class="rb-input-wrap">
      <div>
        <input
          type="text"
          v-model="text"
          :placeholder="data.options.placeholder"
          :maxlength="data.options.maxChars"
          @change="notifyChange"
          :id="`step-${data.id}-message`"
        />
      </div>
      <div class="rb-input-details">
        <div>{{ text.length }} characters</div>
        <div>Max. {{ data.options.maxChars }} characters</div>
      </div>
    </div>
  </div>
</template>
<script>
/**
 * Widget to display a text input for the current step
 *
 *
 * @implements
 * ChildMixin
 * CommMixin
 * TrackMixin
 *
 * @listens
 * rb-step-display-update
 *
 * @emits
 * rb-step-complete
 * rb-step-incomplete
 */
import TrackMixin from "@/mixins/TrackMixin";
import ChildMixin from "@/mixins/ChildMixin";
import CommMixin from "@/mixins/CommMixin";
export default {
  mixins: [ChildMixin, CommMixin, TrackMixin],
  watch: {
    text: function () {
      //return true;
      if (
        this.text.length >= 0 &&
        this.text.length <= this.data.options.maxChars
      ) {
        this.notifyComplete();
      } else {
        this.notifyIncomplete();
      }
    },
  },
  data: function () {
    return {
      text: "",
    };
  },
  mounted: function () {
    // this.notifyComplete();
    this.subscribe("rb-step-display-update", this.onStepDisplayUpdate);
  },
  methods: {
    onStepDisplayUpdate: function (stepData) {
      // console.log("qwr", stepData);
      if (stepData.id === "engraving") {
        this.notifyComplete();
      }
    },
    notifyComplete: function () {
      this.broadcast("rb-step-complete", {
        step: this.data,
        choice: { value: this.text },
      });
    },
    notifyIncomplete: function () {
      this.broadcast("rb-step-incomplete", { step: this.data });
    },
    notifyChange: function (event) {
      this.trackEvent(
        this.formatTracking(this.getTrackId(event), this.TRACK_INPUT),
        this.getTrackId(event),
        {
          engraving: this.text,
        }
      );
    },
  },
};
</script>
